import React, { useState } from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { CockpitMode, IssueStatus } from '@/utils/type';
import TransferIssueModal from '@/components/TransferIssueModal';
import classNames from 'classnames';
import { getClstag } from '@/utils/util';

const TransferIssue = (props: {
  vehicleName: string;
  closeDropdown: () => void;
}) => {
  const { vehicleName, closeDropdown } = props;
  const [open, setOpen] = useState(false);
  const { cockpitMode } = useSelector((state: RootState) => state.newCommon);
  const { list } = useSelector((state: RootState) => state.issue);
  const { issueStatus, issueNumber } =
    list?.find((workOrder: any) => {
      return workOrder.vehicleName === vehicleName;
    }) || {};
  const usable =
    (issueStatus === IssueStatus.PROCESS ||
      issueStatus === IssueStatus.ON_HOLD) &&
    [CockpitMode.LISTENING_MODE, CockpitMode.WATCH_CAR_MODE].includes(
      cockpitMode
    );
  return (
    <>
      <button
        className="issue-command-btn"
        disabled={!issueNumber || !usable}
        onClick={() => {
          if (!issueNumber) {
            return;
          }
          usable && setOpen(true);
          closeDropdown();
        }}
        clstag={
          usable ? getClstag(cockpitMode, 'SinglePage_TransferIssue') : ''
        }
      >
        转单
      </button>
      <TransferIssueModal
        open={open}
        setOpen={setOpen}
        vehicleName={vehicleName}
        type="TRANSFER"
      />
    </>
  );
};

export default React.memo(TransferIssue);
